<template>
  <header class="header">
    <div class="header__left">
      <PhList @click="burgerVisible = true" class="header__burger" />

      <div class="header__logo">
        <PhWine />
        <span>ViniSuivi</span>
      </div>
    </div>

    <div class="header__right">
      <!-- Titre de la page -->
      <HeaderTitleComponent class="header__title--large" />
    </div>
  </header>

  <!-- Titre de la page -->
  <HeaderTitleComponent class="header__title--mobile" />

  <Teleport to="body">
    <BurgerComponent v-model="burgerVisible" />
  </Teleport>
</template>

<script setup lang="ts">
import { PhWine, PhList } from '@phosphor-icons/vue'
import { ref, type Ref } from 'vue'
import BurgerComponent from '@/components/BurgerComponent.vue'
import HeaderTitleComponent from '@/components/header/HeaderTitleComponent.vue'

const burgerVisible: Ref<boolean> = ref(false)
</script>
